export const QA_STATUS_LABELS = {
  PENDIENTE_REVISION: { label: 'Pendiente ronda 1', bg: '#ffebee', color: '#c62828' },
  REVISION_1_APROBADA: { label: 'Pendiente ronda 2', bg: '#fff3e0', color: '#e65100' },
  REVISION_1_RECHAZADA: { label: 'Rechazado (ronda 1)', bg: '#ffebee', color: '#c62828' },
  REVISION_2_APROBADA: { label: 'Aprobado', bg: '#e8f5e9', color: '#2e7d32' },
  REVISION_2_RECHAZADA: { label: 'Rechazado (ronda 2)', bg: '#ffebee', color: '#c62828' }
};

export const getQaStatusInfo = (qaStatus) => QA_STATUS_LABELS[qaStatus] || QA_STATUS_LABELS.PENDIENTE_REVISION;
